import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

// Shown before an invoice-generating action (direct generate, bulk/single
// status change, mass update, pickup) proceeds, when some of the selected
// packages already have an active invoice. Lets the user decide how to
// proceed instead of silently creating a duplicate invoice.
//
// mode="generate": plain invoice generation, no status change involved -
//   only "remove conflicting packages" or "cancel" make sense.
// mode="statusChange": the action also changes packageStatus - adds a third
//   choice to change status for every package but skip invoicing only the
//   conflicting ones.
function InvoiceConflictDialog({ visible, conflicts = [], mode = "generate", onRemoveAndContinue, onProceedAnyway, onCancel }) {
    const conflictWaybills = conflicts.map((c) => c.Waybill);
    const plural = conflicts.length > 1;

    return (
        <Dialog header="Package(s) already invoiced" visible={visible} style={{ width: "700px" }} modal onHide={onCancel}>
            <p>
                {conflicts.length} package{plural ? "s" : ""} in this selection already {plural ? "have" : "has"} an active invoice. Generating again would create a duplicate.
            </p>
            <div style={{ maxHeight: 300, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 8, marginBottom: 16 }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85rem" }}>
                    <thead>
                        <tr style={{ background: "#f8fafc", textAlign: "left" }}>
                            <th style={{ padding: 8 }}>Waybill</th>
                            <th style={{ padding: 8 }}>Invoice #</th>
                            <th style={{ padding: 8 }}>Date</th>
                            <th style={{ padding: 8 }}>Amount</th>
                            <th style={{ padding: 8 }}>Payment</th>
                            <th style={{ padding: 8 }}>Client</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conflicts.map((c) => (
                            <tr key={c.Waybill} style={{ borderTop: "1px solid #e2e8f0" }}>
                                <td style={{ padding: 8 }}>{c.Waybill}</td>
                                <td style={{ padding: 8 }}>{c.invoice?.invoiceId || c.invoice?.invoiceNo || "-"}</td>
                                <td style={{ padding: 8 }}>{c.invoice?.date || "-"}</td>
                                <td style={{ padding: 8 }}>{c.invoice?.invoiceAmount ?? "-"}</td>
                                <td style={{ padding: 8 }}>{c.invoice?.paymentStatus || "-"}</td>
                                <td style={{ padding: 8 }}>{c.invoice?.clientName || "-"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
                {mode === "statusChange" && <Button label="Change Status, Skip Invoice for These" className="p-button-outlined" onClick={onProceedAnyway} />}
                <Button label="Remove Flagged Package(s) & Continue" className="p-button-warning" onClick={() => onRemoveAndContinue(conflictWaybills)} />
                <Button label="Cancel" className="p-button-secondary p-button-text" onClick={onCancel} />
            </div>
        </Dialog>
    );
}

export default InvoiceConflictDialog;
